import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M91.125 86.665a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M91.125 19.516a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6.566 67.225a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M26.725 89.608a1.5 1.5 0 0 1 0 2.122l-9.995 9.993a1.5 1.5 0 0 1-2.121-2.122l9.994-9.993a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M14.61 89.608a1.5 1.5 0 0 1 2.12 0l9.994 9.993a1.5 1.5 0 0 1-2.12 2.122l-9.995-9.993a1.5 1.5 0 0 1 0-2.122M95.108 55.158a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 1 1-3 0V56.658a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M86.542 63.726a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H88.042a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#8F9BA8"
      fillRule="evenodd"
      d="M75.443 28.276v.007l-.001.03-.004.133q-.006.179-.013.557c-.01.506-.024 1.285-.032 2.367-.017 2.163-.018 5.537.049 10.355.077 5.562-2.104 9.537-5.568 12.755-3.11 2.89-7.337 5.233-11.75 7.68l-.888.492c-4.877 2.71-9.302 5.222-12.525 7.955-3.217 2.728-4.844 5.346-4.844 8.201v10.874a2.25 2.25 0 0 1-4.5 0V78.808c0-4.797 2.804-8.555 6.433-11.633 3.624-3.073 8.461-5.796 13.25-8.457q.342-.188.676-.375c4.626-2.567 8.392-4.658 11.085-7.16 2.678-2.487 4.188-5.292 4.131-9.395a487 487 0 0 1-.049-10.454 192 192 0 0 1 .05-3.16l.002-.04v-.014l2.25.077-2.25-.078a2.25 2.25 0 0 1 4.498.157"
      clipRule="evenodd"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M73.194 67.296a2.25 2.25 0 0 1 2.25 2.25v19.33a2.25 2.25 0 0 1-4.5 0v-19.33a2.25 2.25 0 0 1 2.25-2.25M37.08 28.23a2.25 2.25 0 0 1 2.25 2.25v26.178a2.25 2.25 0 0 1-4.5 0V30.48a2.25 2.25 0 0 1 2.25-2.25"
      clipRule="evenodd"
    />
    <path
      fill="#8F9BA8"
      fillRule="evenodd"
      d="M73.16 23.666a2.25 2.25 0 0 1 1.713.752l11.14 12.485a2.25 2.25 0 1 1-3.357 2.996l-9.41-10.545-8.801 10.493a2.25 2.25 0 1 1-3.448-2.892L71.47 24.47a2.25 2.25 0 0 1 1.69-.804"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconChangeOrdersGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconChangeOrdersGreyscale);
export default Memo;
